import FilterList from "@mui/icons-material/FilterList";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { SmallBody, SmallBodyHighlight } from "helpers/TypographyComponents";
import { useState } from "react";

import StyledPopover from "../StyledPopover";
import styles from "./style.module.scss";
import type { MultiDataFilterGroup, MultiDataFiltersChosenOption } from "./utils";
import { getDefaultChosenOptions } from "./utils";

interface IMultiDataFilters {
    /**
     * Filters groups
     */
    filterGroups: MultiDataFilterGroup[];
    /**
     * Handle chose filters action
     */
    handleChoseFilters: (value: string, groupLabel: string) => void;
}

/**
 * Render a btn that open a popover with props passed filters
 */
const MultiDataFilters = ({ filterGroups, handleChoseFilters }: IMultiDataFilters) => {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const defaultChosenOptions = getDefaultChosenOptions(filterGroups);

    const [chosenOptions, setChosenOptions] = useState<MultiDataFiltersChosenOption>(defaultChosenOptions);

    const showPopover = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleChoseOption = (e, value: string, groupLabel: string) => {
        setChosenOptions((prev) => ({ ...prev, [groupLabel]: value }));
        handleChoseFilters(value, groupLabel);
    };

    return (
        <div className={styles["multi-data-filters"]}>
            <button onClick={handleClick}>
                <FilterList />
            </button>
            <StyledPopover open={showPopover} onClose={() => setAnchorEl(null)} anchorEl={anchorEl} multicolor>
                <div className={styles["filters-groups-wrapper"]}>
                    {filterGroups.map((group) => {
                        return (
                            <div key={group.label}>
                                <SmallBodyHighlight color="grey">{group.label} :</SmallBodyHighlight>
                                <RadioGroup onChange={(e, value) => handleChoseOption(e, value, group.label)}>
                                    {group.options.map((option) => {
                                        const checked = chosenOptions[group.label] === option.value;
                                        return (
                                            <FormControlLabel
                                                className={styles["group-option"]}
                                                key={option.label}
                                                value={option.value}
                                                checked={checked}
                                                control={<Radio />}
                                                label={<SmallBody>{option.label}</SmallBody>}
                                            />
                                        );
                                    })}
                                </RadioGroup>
                            </div>
                        );
                    })}
                </div>
            </StyledPopover>
        </div>
    );
};

export default MultiDataFilters;
